import React, { useCallback, useContext, useState } from 'react';

import { Drawer, message } from 'antd' 

import { ResponsiveContext } from '~/contexts/ResponsiveContext'

import Button from '~/components/button';
import Input from '~/components/input'


import { cnpjMask, cpfMask } from '~/utils/Masks';
import Api from '~/utils/SocialMeAPI';

import Flex from './style'

import PersonHeader from './components/PersonHeader';

export default function SearchAdmin({ institutionId }) {
    const { isMobile } = useContext(ResponsiveContext)
    const [search, setSearch] = useState("");
    const [ loading, setLoading ] = useState(false)
    const [person, setPerson] = useState();
    const [visible, setVisible] = useState(false);

    const showDrawer = () => {
      setVisible(true);
    };
    const onClose = () => {
      setVisible(false);
    };

    const GetInstitution = useCallback(async (value) => {
      setLoading(true)

      const filter = {}

      if (value.length > 14) {
        filter.cnpj_number =  value.replace(/[^\d]+/g, '')
      } else {
        filter.cpf_number =  value.replace(/[^\d]+/g, '')
      }
     
      const params = {
        operation: ["SIGAM","Admin", "Search"],
        data: {
          filter
        }
      }

      const response = await Api(params)

      if (response.success) {
        const items = response.body.peopleList.elements

        if (items.length === 0) {
          message.error("Nenhum administrador foi encontrado")
        } else {
          setPerson(response.body.peopleList.elements[0])
        }
       
      } else {
        message.error("Houve um erro ao buscar um administrador")
      }

      setLoading(false)
    }, [])

  const isCpfOrCnpj = useCallback((data) => {
    if (data.length > 14) {
      return cnpjMask(data)
    } 

    return cpfMask(data)
  }, [])

  return (
    <>
        <Button onClick={showDrawer} >
            Vincular Administrador
        </Button>
        <Drawer title="Vincular um administrador na instituição" width={isMobile ? "100vw" : "35vw"} placement="right" onClose={onClose} visible={visible}>
          {person && (
            <PersonHeader onClose={onClose} institutionId={institutionId} setPerson={setPerson} person={person} />
          )}
         
          <Flex>
            <Input placeholder="CPF" value={search} onChange={({ target }) => setSearch(isCpfOrCnpj(target.value))} />
            <Button onClick={() => GetInstitution(search)} loading={loading} style={{ marginLeft: 10}} type={!person && "primary"}>Buscar</Button>
          </Flex>
        </Drawer>
    </>
  );
}
